import { INICIALIZAR } from '../actions';
export default function configIndice() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case INICIALIZAR:
      return action.config.configIndice;

    default:
      return state;
  }
}